<script setup>
/* eslint-disable */
import { onMounted, computed, watch, ref } from 'vue';
import { defineProps, defineEmits } from 'vue';
import { useRouter } from 'vue-router';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useLiveSportOverview } from '@/stores/live_sport_overview';
import { useFixtureStore } from '@/stores/fixture';
import { useSportUpcomingStore } from '@/stores/sport_upcoming';
import { useCouponsStore } from '@/stores/coupons';

import EsportFixtureDoubleMarket from './EsportFixtureDoubleMarket.vue';
import LoaderComponent from '@/components/Common/LoaderComponent.vue';
import EsportFixtureDoubleMarketUpcoming from './EsportFixtureDoubleMarketUpcoming.vue';

const router = useRouter();
const liveSportsStore = useLiveSportsStore();
const preSportsStore = usePreSportsStore();
const liveSportOverviewStore = useLiveSportOverview();
const fixtureStore = useFixtureStore();
const sportUpcomingStore = useSportUpcomingStore();
const couponsStore = useCouponsStore();

const competitionStates = ref({}); // Track the open/closed state for each competition
const competition_closed = ref(false);
const competitions_closed = ref({});
const props = defineProps({
	upcomingData: Array,
  competition: Array, // Example, adjust based on actual prop type
	primary_overview_market: {
		type: Object,
		required: true,
	},
	secondary_overview_market: {
		type: Object,
		required: true,
	},
});
const emit = defineEmits(['update:competitions_closed']);
onMounted( async () => {
	return;
	const allRes = await global.axios.get(process.env.VUE_APP_ESPORTS_ALL, { withCredentials: false });
	let selected_esport = allRes.data;
	if (selected_esport[21].sport_id) {
		var esport = selected_esport[21].sport_id;
	} else {
		var esport = preSportsStore.esports[0].id;
	}
	let payload = {
		sport_id: esport,
		hours: 3
	};

	if (payload.sport_id == '' || payload.sport_id == null) return;

	couponsStore.setFixturesLoading(true);
	// couponsStore.fetchNextHourFixtures(payload);
});

watch(() => preSportsStore.selected_esport_id, (newSportId, oldSportId) => {
	if (oldSportId > 0) {}

	if (newSportId > 0) {
		let payload = {
			sport_id: newSportId,
			hours: 3
		};

		couponsStore.setFixturesLoading(true);
		// couponsStore.fetchNextHourFixtures(payload);
	}
});


// Toggle the competition state for a specific competition
const toggleCompetitionState = (index) => {
  // Toggle the specific competition's open/close state
  competitionStates.value[index] = !competitionStates.value[index];
};

</script>

<template>
	<LoaderComponent v-if="couponsStore.fixtures_loading"/>
	<div id="upcoming" class="tab-content" v-else v-for="item in upcomingData" :key="item.id">
			<div class="dashboard-info-label">
				<div class="sport-title">
					<img :src="preSportsStore.preSportWhiteIcon(item[0].sport_id)" alt="icon">
					<h6 v-if="item && item[0] && item[0].sport_name">{{ item[0].sport_name }}</h6>
				</div>
				<span class="toggle-markets">
					<div @click="competitions_closed[item[0].sport_id] = !competitions_closed[item[0].sport_id]" class="markets-toggle-fill">
						<svg v-if="!competitions_closed[item[0].sport_id]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="markets-toggle-svg">
							<use xlink:href="/assets/icons/markets_close.svg#markets_close"></use>
						</svg>
						<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="markets-toggle-svg">
							<use xlink:href="/assets/icons/markets_open.svg#markets_open"></use>
						</svg>
						</div>
				</span>
			</div>

		<div class="live-info-outer" v-for="(competition, index) in item" :key="index">
			<div class="live-info-inner">
				<div class="live-info-team">
					<div class="live-match">
						<div class="team-flag">
							<img :src="'/assets' + competition.region_icon_url" alt="">
						</div>
						<div class="live-match-name">
							<h3>{{ competition.region_name }} - {{ competition.competition_name }}</h3>
						</div>
					</div>
				</div>
				<span class="bet-column-empty">
					<div @click="toggleCompetitionState(index)" class="market-arrow">
						<a class="market-arrow-icon" :class="competitionStates[index] ? 'market-arrow-icon-closed' : ''"></a>
					</div>
				</span>
			</div>

			<template v-if="!competitionStates[index] && !competitions_closed[item[0].sport_id]">
				<EsportFixtureDoubleMarketUpcoming
					:key="Index"
					:primary_overview_market="primary_overview_market"
					:secondary_overview_market="secondary_overview_market"
					:fixture="competition"
				/>
			</template>
		</div>
	</div>
</template>